import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { createMuiTheme, ThemeProvider } from '@material-ui/core'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Authentication } from './Authentication'
import ProReference from './pages/proReference/proReference'
import { blue } from '@material-ui/core/colors'
// import { makeAuthenticator, makeUserManager, Callback, SigninResponse } from 'oidc-client'
import { UserContext } from './context/context'
import { UserManager } from 'oidc-client'
import { userManager } from './oidc/oidcsettings'

function checkcookie (name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    const cookieValue = parts.pop().split(';').shift()
    const hasIt = cookieValue && cookieValue !== ''
    return hasIt
  }
  else
    return false
}

function checkURL () {
  const hash = window.location.hash
  return hash?.includes('#id_token=')
}

if (!checkcookie('jwt')) { //check for JWT cookie from Passport Mobile
  if (checkURL()) {
    // process url from callback to store in userManager
    userManager.signinRedirectCallback(window.location.href).then((user) => {
      // get users original path before auth redirect
      const pathname = localStorage.getItem('authredirect') ?? ''
      localStorage.removeItem('authredirect')
      // remove id_token from url
      if (pathname)
        window.location.hash = '/' + pathname?.replace('#/', '')
      else
        window.location.hash = '/'

      renderApplication(user.id_token)
    })
  }
  else if (window.location.hash.startsWith('#/evl'))
    renderApplication()
  else {
    // store user's original path before auth redirect
    userManager.getUser().then((user) => {
      if (user && !user.expired)
        renderApplication(user.id_token)
      else {
        localStorage.setItem('authredirect', window.location.hash)
        userManager.signinRedirect()
      }
    })
  }

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister()
}
else
  renderApplication()

function renderApplication (jwt) {
  try {
    ReactDOM.render(
      <React.StrictMode>
        <Authentication jwt={jwt} />
      </React.StrictMode>,
      document.getElementById('root')
    )
  }
  catch (error) {
    console.log('ERROR', error)
  }
}
